import { useEffect, useState } from "react";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/react";
const SliderInsp = (props) => {
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);

  useEffect(() => {
    const middleIndex = Math.ceil(props.data.length / 2);
    setList1(props.data.splice(0, middleIndex));
    setList2(props.data.splice(-middleIndex));
  }, [props.data]);

  return (
    <div>
      <Swiper
        modules={[Navigation, Scrollbar, A11y, Pagination]}
        slidesPerView={1}
        breakpoints={{
          640: {
            slidesPerView: 1,
          },

          853: {
            slidesPerView: 1,
          },
          1145: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3,
          },
        }}
        style={{ maxHeight: 600 }}
        spaceBetween={10}
        effect={"fade"}
        navigation={true}
        pagination={{
          clickable: true,
        }}
      >
        {list1.map((v, i) => {
          return (
            <SwiperSlide className="">
              <div
                className={`flex flex-col items-center justify-center w-full`}
              >
                <a
                  className={"block relative w-full"}
                  href={v.link}
                  target={"_blank"}
                >
                  <div className="customlinkImage">
                    <div className="imagegradiant"></div>
                    <img
                      className={i % 2 == 0 ? "mb1-2" : "mb12"}
                      src="/main/wandern.svg"
                      alt=""
                      style={{ position: "relative", width: "95%" }}
                    />
                    <h2 className="customlinkItemsTitle mb-5 mr-16">
                      {v.title}
                    </h2>
                  </div>
                </a>
                {list2[i] != undefined && (
                  <a
                    className={"block relative w-full"}
                    href={list2[i].link}
                    target={"_blank"}
                  >
                    <div className="customlinkImage">
                      <div className="imagegradiant"></div>
                      <img
                        src="/main/fitness.svg"
                        alt=""
                        className={i % 2 == 0 ? "mb12" : "mb1-2"}
                        style={{ position: "relative", width: "95%" }}
                      />
                      <h2 className="customlinkItemsTitle mb-5">
                        {list2[i].title}
                      </h2>
                    </div>
                  </a>
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default SliderInsp;
